import Administrador from "pages/LandingPages/Administrador/administrador";

export default function AdministradorPage() {
  return <Administrador />;
}
